/* eslint-disable no-param-reassign */
import { createEntityReducer } from 'util/reducers'

export default createEntityReducer('excludedDomains')
